export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-black text-white overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/c4c806a479ca4f0c6bda7b2f526ac661.png"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center w-full">
        <div className="inline-block mb-6 px-4 py-2 bg-orange-500/20 border border-orange-500 rounded-full">
          <span className="text-orange-500 text-xs sm:text-sm font-semibold tracking-wide">Temporada 2026</span>
        </div>
        
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Campeonato Brasileiro de<br />Ginetta G55 Supercup 2026
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed px-4">
          Campeonato oficial, com seletiva classificatória e divisão em Série A e Série B na plataforma Automobilista 2
        </p>

        {/* Logo */}
        <div className="mb-8 sm:mb-12 flex justify-center">
          <img 
            src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/f87325baca69aa8ba2d9715825ce3361.png" 
            alt="Ginetta G55 Supercup Logo" 
            className="h-32 sm:h-40 md:h-48 w-auto drop-shadow-2xl"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
          <a 
            href="https://forms.gle/tTc5BatSeyfwnPFJ8"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 text-sm sm:text-base whitespace-nowrap cursor-pointer"
          >
            Fazer inscrição
          </a>
          <a 
            href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 text-sm sm:text-base whitespace-nowrap cursor-pointer"
          >
            Entrar no grupo oficial
          </a>
          <a 
            href="https://www.youtube.com/@italentvseries"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-3 bg-transparent border-2 border-white hover:bg-white hover:text-black text-white font-semibold rounded-lg transition-all duration-300 text-sm sm:text-base whitespace-nowrap cursor-pointer"
          >
            YouTube iTalent V-Series
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
